// The flagship Global Alumni Meet, as announced on the institute's poster.
// Every figure below is read off that poster; nothing is inferred.

export const ALUMNI_MEET = {
  title: "Global Alumni Meet",
  kannada: "ಸವಿನೆನಪು",
  tagline: "Reconnect. Relive. Reimagine.",
  motto: "One Legacy, A Global Family.",
  blurb:
    "A celebration of our shared journey, timeless memories and the spirit that continues to unite BIETians across the world.",
  /** Local calendar date of the meet, 11:00 IST. */
  startsAt: "2026-12-19T11:00:00+05:30",
  dateLabel: "19 December 2026",
  weekday: "Saturday",
  timeLabel: "11:00 AM",
  venue: "SSM Cultural Center",
  place: "Davanagere, Karnataka",
  poster: {
    url: "/alumni/global-alumni-meet-2026.jpg",
    alt: "Poster for the BIET Global Alumni Meet, Savinenapu, on Saturday 19 December 2026 at 11:00 AM at the SSM Cultural Center, Davanagere",
    width: 1536,
    height: 1024,
  },
  pillars: [
    { head: "Reconnect", text: "with old friends and batchmates" },
    { head: "Network", text: "with alumni across the globe" },
    { head: "Inspire", text: "and be inspired" },
    { head: "Collaborate", text: "for a stronger tomorrow" },
    { head: "Give back", text: "to nurture the legacy" },
  ],
} as const;

/** Whole days from `now` until the meet; 0 on the day, null once it has passed. */
export function daysUntilMeet(now: Date = new Date()): number | null {
  const ms = new Date(ALUMNI_MEET.startsAt).getTime() - now.getTime();
  if (ms < 0) return null;
  return Math.ceil(ms / 86_400_000);
}
